// 流程操作
import React from 'react'
import { connect } from 'react-redux'
import { nullDate, TDate } from '../../public/utility'
import { hasChangedValues } from '../../public/utility/formValues'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, addListItemsFromListItems, resetListValues, isListValuesChanged, cloneListItem } from '../../public/utility'
import ProcessOperateTargetStatusDiv from './ProcessOperateTargetStatusDiv'
import ProcessOperateFormItemDiv from './ProcessOperateFormItemDiv'

class ProcessOperateDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetProcessOperate(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetProcessOperate = (id) => {
        Tyan.doPostEvent({
            event: 'GetProcessOperate',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { ProcessStatusID } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessOperate',
            data: { id, ProcessStatusID, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    this.doGetProcessOperate(id)
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onRefresh, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteProcessOperate',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerClose = () => {
        const { onRefresh, onClose } = this.props
        if (!this.bChanged()) {
            onRefresh && onRefresh()
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => {
            onRefresh && onRefresh()
            onClose && onClose()
        })
    }

    handleAddProcessOperateTargetStatus = () => {
        const { ProcessStatusID } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessOperate',
            data: { id, ProcessStatusID, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    Tyan.pubForm.showDialog('带条件目标状态', props => <ProcessOperateTargetStatusDiv {...props} id={0} ProcessOperateID={id} onRefresh={() => this.doGetProcessOperate(id)} />)
                }
            }
        })
    }

    handleAddProcessOperateFormItem = () => {
        const { ProcessStatusID } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessOperate',
            data: { id, ProcessStatusID, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    Tyan.pubForm.showDialog('关联表单项', props => <ProcessOperateFormItemDiv {...props} id={0} ProcessOperateID={id} onRefresh={() => this.doGetProcessOperate(id)} />)
                }
            }
        })
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.操作名称 && values.目标状态
    }

    fieldset基本信息 = () => {
        return [
            { _text: '操作名称', required: true, minWidth: '45%' },
            { _text: '目标状态', required: true, minWidth: '45%' },
            { _radio: '自动触发', minWidth: '95%' },
            { _text: '数据验证', minWidth: '95%', maxRows: 5 },
            { _text: '执行代码', minWidth: '95%', maxRows: 5 },
        ]
    }

    fieldset带条件目标状态 = () => {
        const { id } = this.state
        return [{
            _grid: '', name: '带条件目标状态', rowNumbers: true, minRows: 3, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '目标状态', flex: 2 },
                { _text: '条件', flex: 5 },
            ],
            buttons: [
                { _button: '添加...', /* icon: 'plus', */  handler: this.handleAddProcessOperateTargetStatus, },
            ],
            onDoubleTap: data => {
                Tyan.pubForm.showDialog('带条件目标状态', props => <ProcessOperateTargetStatusDiv {...props} id={data.id} ProcessOperateID={id} onRefresh={() => this.doGetProcessOperate(id)} />)
            }
        }]
    }

    fieldset表单项 = () => {
        const { id } = this.state
        return [{
            _grid: '', name: '表单项', rowNumbers: true, minRows: 3, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '表单项名称', flex: 2 },
                { _text: '条件', flex: 5 },
            ],
            buttons: [
                { _button: '添加...', /* icon: 'plus', */  handler: this.handleAddProcessOperateFormItem, },
            ],
            onDoubleTap: data => {
                Tyan.pubForm.showDialog('关联表单项', props => <ProcessOperateFormItemDiv {...props} id={data.id} ProcessOperateID={id} onRefresh={() => this.doGetProcessOperate(id)} />)
            }
        }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="800" maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', height: '400' },
                    // { title: '带条件目标状态', name: '基本信息', _fieldset: this.fieldset带条件目标状态(), fullblock: true, docked: 'bottom' },
                    // { title: '表单项', name: '基本信息', _fieldset: this.fieldset表单项(), fullblock: true, docked: 'bottom' },
                    {
                        _fieldsets: [
                            { title: '带条件目标状态', name: '基本信息', _fieldset: this.fieldset带条件目标状态(), fullblock: true },
                            { title: '表单项', name: '基本信息', _fieldset: this.fieldset表单项(), fullblock: true },
                        ], height: '400'
                    }
                ]}
        />
    }
}

export default connect()(ProcessOperateDiv)